import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class TaskBlockService extends BaseService {
	constructor() {
		super('/taskblock');
	}

	public getAllByFilter(filter: TaskBlockFilter) {
		return super.getAllByFilterBase(filter);
	}

	//public getContentList(taskId: number) {
	//	return super.getByIdWithResourceName(taskId, this._resourceName + '/content');
	//}

	///*update, pridani medii k u tasku*/
	//public updateContentsToTask(id: number, components: any) {
	//	return super.updateBase(this._resourceName + '/contents-to-task/' + id, components);
	//}

		public updateAllTaskBlock( components: any) {
			return super.updateBase(this._resourceName + '/save-all-taskblock', components);
	}
}

export class TaskBlockFilter extends BaseFilter {
	constructor(idTask?: number | null) {
		super();
		this._idTask = idTask;
	}

	private _idTask?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTask != null ? { IdTask: this._idTask } : {})
		);

		return data;
	};
}